export interface Model {
  id: string;
  name: string;
  credits: number;
}

export const models: Model[] = [
  {
    id: 'google-nano-banana-edit',
    name: 'Google Nano Banana Edit',
    credits: 40,
  },
  {
    id: 'openai-dalle-edit',
    name: 'OpenAI DALL-E Edit',
    credits: 50,
  },
  {
    id: 'stable-diffusion-edit',
    name: 'Stable Diffusion Edit',
    credits: 35,
  },
];

